import type { TaggingActionPayload } from '../../models'
import type { ContextProvider } from '../../providers'
import type { TaggingComposable, TaggingParameters } from './types'
// @ts-strict-ignore
import { getCurrentInstance } from 'vue'
import { CONTAINER } from '../../config'
import { TYPES } from '../../config/inversify.types'
import { TAGGING_CONSTS } from '../../store/tagging/tagging.consts'
import { TaggingUtils } from '../../utils'
import { mapActions } from '../utils'

export const useTagging = (): TaggingComposable => {
  const {
    proxy: { $store },
  } = getCurrentInstance()

  const { tagAction } = mapActions($store, TAGGING_CONSTS.moduleName, {
    tagAction: TAGGING_CONSTS.actions.tagAction,
  })

  const taggingAction = async (taggingParameters: TaggingParameters): Promise<void> => {
    const { domain } = CONTAINER.get<ContextProvider>(TYPES.ContextProvider)()
    const taggingPayload: TaggingActionPayload = {
      ...TaggingUtils.getTaggingPayload(taggingParameters.featureId, domain),
      type: taggingParameters.type,
      ...(taggingParameters.component && { component: taggingParameters.component }),
    }
    await tagAction(taggingPayload)
  }

  return {
    taggingAction,
  }
}
